import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=2031f33a&"
import script from "./tab-bar.vue?vue&type=script&lang=js&"
export * from "./tab-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2031f33a')) {
      api.createRecord('2031f33a', component.options)
    } else {
      api.reload('2031f33a', component.options)
    }
    module.hot.accept("./tab-bar.vue?vue&type=template&id=2031f33a&", function () {
      api.rerender('2031f33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/tabs/src/tab-bar.vue"
export default component.exports